export default __webpack_public_path__ + "static/media/avatar_xiao_mei4.bd023322.mp3";